module.exports = __webpack_public_path__ + "static/img/nav_8.cd8ee2a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/comm/images/document-conversion/homeSVG/nav_8.svg
// module id = zEPw
// module chunks = 2